import { render, staticRenderFns } from "./WebTabDeleted.vue?vue&type=template&id=41bfa13a"
import script from "./WebTabDeleted.vue?vue&type=script&lang=js"
export * from "./WebTabDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports